import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	searchPlaceholder: {
		id: 'content-state.menu.v2.search-placeholder',
		defaultMessage: 'Search or add',
		description: 'Placeholder text for the search input',
	},
	defaultWorkflow: {
		id: 'content-state.menu.v2.default-workflow',
		defaultMessage: 'Default workflow',
		description: 'Section title for default/suggested statuses',
	},
	customStatuses: {
		id: 'content-state.menu.v2.custom-statuses',
		defaultMessage: 'Custom statuses',
		description: 'Section title for custom statuses',
	},
	addCustomStatus: {
		id: 'content-state.menu.v2.add-custom-status.title',
		defaultMessage: 'Add as custom status',
		description: 'Button title to add a new custom status',
	},
	addCustomStatusDescription: {
		id: 'content-state.menu.v2.add-custom-status.description',
		defaultMessage: 'Only you can choose this',
		description: 'Button description for add custom status button',
	},
	addCustomStatusHeader: {
		id: 'content-state.menu.v2.add-custom-status-view.header',
		defaultMessage: 'Add custom status',
		description: 'Header for the add custom status view',
	},
	statusNamePlaceholder: {
		id: 'content-state.menu.v2.status-name.placeholder',
		defaultMessage: 'Status name',
		description: 'Placeholder for status name input in the status view dialog',
	},
	cancel: {
		id: 'content-state.menu.v2.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button label',
	},
	save: {
		id: 'content-state.menu.v2.save',
		defaultMessage: 'Save',
		description: 'Save button label',
	},
	changeStatus: {
		id: 'content-state.menu.v2.change-status',
		defaultMessage: 'Change status',
		description: 'Header text when changing an existing status',
	},
	clear: {
		id: 'content-state.menu.v2.clear',
		defaultMessage: 'Clear',
		description: 'Button to clear/remove the current status',
	},
	startApproval: {
		id: 'content-state.menu.v2.start-approval',
		defaultMessage: 'Start approval',
		description: 'Label for the start approval button in the in review status option',
	},
	approvalBetaTag: {
		id: 'content-state.menu.v2.color-picker.option.aria-label',
		defaultMessage: 'Beta',
		description: 'Beta label for approval feature',
	},
	rovo: {
		id: 'content-state.menu.v2.rovo',
		defaultMessage: 'Agent',
		description: 'Button to invoke Rovo AI assistant for the current content state',
	},
	colorPickerLabel: {
		id: 'content-state.menu.v2.color-picker.aria-label',
		defaultMessage: 'Color picker selector',
		description: 'Aria label for the add custom status color picker',
	},
	colorOption: {
		id: 'content-state.menu.v2.color-picker.option.aria-label',
		defaultMessage: 'Color option',
		description: 'Aria label for the add custom status color options within the color picker',
	},
});
